




import { defineComponent, inject } from '@nuxtjs/composition-api';
import { RailsHost } from '~/plugins/global-setup/provide_enviroment_hosts';
import useAppRoute from '~/compositions/useAppRoute';

/**
 * コンポーネントの始まり
 */
export default defineComponent({
  /**
   * このコンポーネントの初期化処理
   * (第一引数は props, 第二引数は SetupContext)
   */
  setup(_props, context) {
    const { URLs, redirect } = useAppRoute();

    // console.log(context.root.$route);
    const full = context.root.$route.fullPath;
    const path = context.root.$route.path;
    const query = context.root.$route.query;

    // TODO: アプリリリース時にバイパスする必要が出てきたもの
    //       何のページなのか把握していないので、後で柳本さんに確認
    const domain = `${inject(RailsHost)}${full}`;

    // 旧 Rails に飛ばす
    location.href = domain;

    // console.log('aaaaa');
    // console.log(full);
    // console.log(path);
    // console.log(query);
    // console.log(domain);

    return {
      domain,
      full,
      path,
      query,
    };
  },
});
